<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "PermissionRoleAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  